var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.togglePublishedState}},[_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.top",modifiers:{"hover":true,"top":true}}],staticClass:"label label-dot mr-2",class:_vm.labelState['class'],attrs:{"title":_vm.labelState['title']}})])
}
var staticRenderFns = []

export { render, staticRenderFns }